import React from 'react';

import { TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';
import { ButtonType } from 'antd/lib/button';

import { Button } from 'components/Button';

import { Modal } from './Modal';

/** similar interface to Modal.confirm but an actual recurrency styled modal */
export function ConfirmModal({
  title,
  content,
  okText = 'OK',
  okType = 'primary',
  permissionsRequired,
  cancelText = 'Cancel',
  width = 600,
  className,
  onClose,
}: {
  title: React.ReactNode;
  content?: React.ReactNode;
  okText?: string;
  okType?: ButtonType;
  permissionsRequired?: TenantUserPermission[];
  cancelText?: string;
  width?: number;
  className?: string;
  onClose: (didConfirm: boolean) => void;
}) {
  return (
    <Modal
      visible
      title={title}
      onCancel={() => onClose(false)}
      width={width}
      className={className}
      destroyOnClose
      footer={
        <>
          <Button onClick={() => onClose(false)}>{cancelText}</Button>
          <Button onClick={() => onClose(true)} type={okType} permissionsRequired={permissionsRequired}>
            {okText}
          </Button>
        </>
      }
    >
      {content}
    </Modal>
  );
}
